import { isValid } from 'iban-ts';

document.addEventListener('DOMContentLoaded', function() {
  /**
   * Wizard options
   */

  // Get all card sections
  const cardSections = document.querySelectorAll('.cards__group');

  // Get the final price element
  const finalPriceElement = document.querySelector('.nodi-wizard-options__final-price');

  // Track the state if button to show the form has been clicked
  let initialClickToShowForm = false;
  let formLocked = false;

  const updateNextButtonState = () => {
    const nextBtn = document.querySelector('.nf-next-item .nf-next');
    if (!nextBtn) return;

    const invalidPhoneExists = document.querySelector(
      'input[type="tel"][data-phone-valid="false"]'
    );

    nextBtn.disabled = !!invalidPhoneExists;
  };

  // Add event listener to each card
  document.querySelectorAll('.card--wizard').forEach((card) => {
    card.addEventListener('click', () => {
      const clickedGroup = card.closest('.cards__group');
      const isFirstGroup = Array.prototype.indexOf.call(cardSections, clickedGroup) === 0;
      let couponField = document.querySelector('.nf-field-container.coupon-code input');
      let couponError = document.querySelector('.nf-field-container .coupon-error');

      // Reset coupon field value
      if(couponField) {
        couponField.value = '';
      }

      // Reset coupon error
      if(couponError) {
        couponError.textContent = '';
      }

      if (isFirstGroup) {
        // If clicking the same main card again, do NOT reset
        if (card.classList.contains('active')) {
            return;
        }

        document.querySelectorAll('.card--wizard.active').forEach((c) => {
            c.classList.remove('active');
        });

        cardSections.forEach((section, index) => {
            if (index === 0) {
                section.classList.remove('hidden');
            } else {
                section.classList.add('hidden');

                // Hide cards inside those groups
                section.querySelectorAll('.card--wizard').forEach((c) => {
                    c.classList.remove('active');
                    c.classList.add('hidden');
                });
            }
        });

        finalPriceElement.innerHTML = "";
        localStorage.removeItem('summaryHtml');
        localStorage.removeItem('serviceOffers');
        localStorage.removeItem('spoedtoeslag');

        resetProgressBar();

        let form = document.querySelector('.nodi-wizard-options__form form');
        if(form) {
            form.reset();
        }
      }

      const currentSlug = card.getAttribute('data-item-slug');
      const nextSection = cardSections[Array.prototype.indexOf.call(cardSections, card.closest('.cards__group')) + 1];
      const currentMainItem = document.querySelector('.cards--wizard .cards__group:first-child .card--wizard.active');
      const mainItems = document.querySelectorAll('.cards__group');
      const lastMainItem = mainItems[mainItems.length - 1];
      let currentMainSlug = false;
      let serviceOffers = [];
      let spoedtoeslag = false;

      if (currentMainItem) {
        currentMainSlug = currentMainItem.dataset.itemSlug;
      }

      // Remove active class for the last cards group to all cards inside the last group
      lastMainItem.querySelectorAll('.card--wizard').forEach((card) => {
        card.classList.remove('active');
      })

      cardSections.forEach((section) => {
        console.log("section", section);
        if (section !== nextSection &&
          Array.prototype.indexOf.call(cardSections, section) > Array.prototype.indexOf.call(cardSections, card.closest('.cards__group'))) {
          section.classList.add('hidden');

          if(section.querySelector('.card--wizard')) {
            section.querySelector('.card--wizard').classList.remove('active');
          }
        }
      });

      if (nextSection) {
        nextSection.classList.remove('hidden');
        nextSection.scrollIntoView({ behavior: 'smooth', block: 'start' });

        // Remove active class from all cards in the next section that are related to the previous group item that is not clicked on
        nextSection.querySelectorAll('.card--wizard').forEach((nextCard) => {
          const activateFor = JSON.parse(nextCard.getAttribute('data-item-activate-for'));
          nextCard.classList.remove('active');

          if (activateFor.includes(currentSlug) || (activateFor.includes(currentMainSlug))) {
            nextCard.classList.remove('hidden');
          } else {
            nextCard.classList.add('hidden');
          }
        });

        // Hide groups if all cards are hidden
        cardSections.forEach((section) => {
          const cardsInSection = section.querySelectorAll('.card--wizard');
          const allCardsHidden = Array.prototype.every.call(cardsInSection, (card) => card.classList.contains('hidden'));
          if (allCardsHidden) {
            section.classList.add('hidden');
          }
        });
      }

      // Remove active class from all cards in the same group
      if (card) {
        card.closest('.cards__group').querySelectorAll('.card--wizard').forEach((siblingCard) => {
          siblingCard.classList.remove('active');
        });

        // Add active class to clicked card
        card.classList.add('active');
      }

      // Calculate final price
      const activeCards = document.querySelectorAll('.card--wizard.active');
      let fixedPriceTotal = 0;
      let monthlyPriceTotal = 0;
      let summaryHtml = '';

      activeCards.forEach((activeCard) => {
        const title = activeCard.querySelector('h3.h4').textContent;
        const priceText = activeCard.querySelector('span.d-block.mt-1.fw-bold') ? activeCard.querySelector('span.d-block.mt-1.fw-bold').textContent : '';
        const price = activeCard.getAttribute('data-item-price') ? parseFloat(activeCard.getAttribute('data-item-price')) : 0;
        const pricePerMonth = activeCard.getAttribute('data-item-price-monthly') ? parseFloat(activeCard.getAttribute('data-item-price-monthly')) : 0;

        if (pricePerMonth) {
          monthlyPriceTotal += pricePerMonth;
        }

        if (price) {
          fixedPriceTotal += price;
        }

        summaryHtml += `<p class="mt-0">${title}: ${priceText}</p>`;
        if (activeCard.getAttribute('data-service-offer-id')) {
          const serviceOfferIds = activeCard.getAttribute('data-service-offer-id').split(',');
          serviceOfferIds.forEach((id) => {
            serviceOffers.push({
              'service_order_id': id.trim(),
            });
          });
        }

        if(title == 'Spoedtoeslag') {
          spoedtoeslag = true;
        }
      });
      console.log("serviceOffers", serviceOffers)


      // Update final price element
      finalPriceElement.innerHTML = `
        <p class="fixed-amount mt-0" data-fixed-amount="${fixedPriceTotal.toFixed(2)}">Totaal eenmalig te voldoen: € ${fixedPriceTotal.toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
        <p class="mt-0">Maandelijkse abonnementsprijs: € ${monthlyPriceTotal.toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
        <h3 class="h4 mt-4 mb-2">Samenvatting van de bestelling:</h3>
        ${summaryHtml}
      `;

      if ( summaryHtml ) {
        localStorage.setItem('summaryHtml', summaryHtml);

        let bodyClasses = document.body.classList;
        let pageIdClass = Array.prototype.filter.call(bodyClasses, function(cls) {
          return cls.startsWith('page-id-');
        })[0];
        let pageId = pageIdClass.split('-')[2];

        if(pageId) {
          document.cookie = 'payment_gateway_page_id=' + pageId + '; expires=' + new Date(Date.now() + 86400000).toUTCString() + '; path=/';
        }
      }

      if ( serviceOffers ) {
        localStorage.setItem('serviceOffers', JSON.stringify(serviceOffers));
      }

      if ( spoedtoeslag ) {
        localStorage.setItem('spoedtoeslag', true);
      }
    });
  });

  /**
   * Progress bar
   */
  const progressBarSteps = document.querySelectorAll('.progress-bar__step');

  if (progressBarSteps) {
    jQuery(document).on('nfFormReady', function() {
      // Get the button and submit button elements
      const button = document.getElementById('js-done-product-select');
      const submitButton = document.querySelector('input[type="submit"]');
      let breadcrumbsContainer = document.querySelector('.nf-mp-header');

      if (button) {
        // Add event listener to the button
        button.addEventListener('click', (e) => {
          toggleFormVisibility(true);

          // Get all progress bar steps
          const progressBarSteps = document.querySelectorAll('.progress-bar__step');

          // Add "done" class to previous steps
          progressBarSteps[0].classList.add('done');
          progressBarSteps[0].classList.remove('active');
          progressBarSteps[0].innerHTML = '<i class="icon-ok">&#10004;</i>';

          progressBarSteps[1].classList.add('active');
        });
      }

      if (submitButton) {
        // Add event listener to the submit button
        submitButton.addEventListener('click', (e) => {
          e.preventDefault();

        });
      }

      // init progress bar update
      updateProgressBarFromBreadcrumbs();
      breadcrumbsContainer = document.querySelector('.nf-mp-header');
      if (breadcrumbsContainer) {
        const observer = new MutationObserver(() => {
          console.log("initial observer run")
          updateProgressBarFromBreadcrumbs();
        });

        observer.observe(breadcrumbsContainer, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'style']
        });
      }

      document.querySelectorAll('.nf-form-cont, .cards--wizard').forEach(element => {
        element.addEventListener('click', () => {
          const activeBreadcrumb = document.querySelector('.nf-breadcrumbs .active');
          const extraPartnerSubs = document.querySelectorAll('.extra-option-partner-subscription-selected');
          const woningtoegangProfessioneleSubs = document.querySelectorAll('.woning-or-professionele-selected');
          let woningtoegangMainCard = document.querySelector('.card[data-item-slug="main_1"]');
          let professioneleSubCard = document.querySelector('.card[data-item-slug="level_2_first_item"]');
          let partnerSubCard = document.querySelector('.card[data-partner-option-card="1"]');
          let noodContactPersonCard = document.querySelector('.card[data-nood-contactpersoon-card="1"]');
          let noodMedicalSectionCards = document.querySelectorAll('.card[data-nood-medical-section-card="1"]');
          let noodAccessSectionCards = document.querySelectorAll('.card[data-nood-access-section-card="1"]');
          // if any child element inside nodi-wizard-options__form or nodi-wizard-options__form itself is clicked do not run the function toggleFormVisibility
          if (!element.classList.contains('nodi-wizard-options__form') && !element.classList.contains('nf-form-cont') && !element.classList.contains('nodi-wizard-options__footer')) {
            console.log("element", element)
            toggleFormVisibility();
          }

          let medicalActive = Array.from(noodMedicalSectionCards).some(card => card.classList.contains('active'));
          let accessActive = Array.from(noodAccessSectionCards).some(card => card.classList.contains('active'));

          if ((woningtoegangMainCard && woningtoegangMainCard.classList.contains('active')) || (professioneleSubCard && professioneleSubCard.classList.contains('active'))) {
            woningtoegangProfessioneleSubs.forEach((card) => {
              card.classList.remove('hidden');
            });

            let checkbox = document.querySelector('.woning-professionele-activate input[type="checkbox"]');
            if (checkbox && !checkbox.classList.contains('nf-checked')) {
              jQuery(checkbox).trigger('click');
            }
          } else {
            woningtoegangProfessioneleSubs.forEach((card) => {
              card.classList.add('hidden');
            });

            let checkbox = document.querySelector('.woning-professionele-activate input[type="checkbox"]');
            if (checkbox && checkbox.classList.contains('nf-checked')) {
              jQuery(checkbox).trigger('click');
            }
          }

          // Partner extra option
          if (partnerSubCard && partnerSubCard.classList.contains('active')) {
            extraPartnerSubs.forEach((card) => {
              card.classList.remove('hidden');
            });

            let checkbox = document.querySelector('.extra-option-partner-activate input[type="checkbox"]');
            let checkbox_step_two = document.querySelector('.extra-option-partner-activate-step-two input[type="checkbox"]');

            if (checkbox && !checkbox.classList.contains('nf-checked')) {
              jQuery(checkbox).trigger('click');
            }

            if (checkbox_step_two && !checkbox_step_two.classList.contains('nf-checked')) {
              jQuery(checkbox_step_two).trigger('click');
            }
          } else {
            extraPartnerSubs.forEach((card) => {
              card.classList.add('hidden');
            });

            let checkbox = document.querySelector('.extra-option-partner-activate input[type="checkbox"]');
            let checkbox_step_two = document.querySelector('.extra-option-partner-activate-step-two input[type="checkbox"]');

            if (checkbox && checkbox.classList.contains('nf-checked')) {
              jQuery(checkbox).trigger('click');
            }

            if (checkbox_step_two && checkbox_step_two.classList.contains('nf-checked')) {
              jQuery(checkbox_step_two).trigger('click');
            }
          }

          // Nood contact person extra option
          if (noodContactPersonCard && noodContactPersonCard.classList.contains('active')) {
            let checkbox = document.querySelector('.extra-option-nood-contactpersoon-activate input[type="checkbox"]');

            if (checkbox && !checkbox.classList.contains('nf-checked')) {
              jQuery(checkbox).trigger('click');
            }
          } else {
            let checkbox = document.querySelector('.extra-option-nood-contactpersoon-activate input[type="checkbox"]');

            if (checkbox && checkbox.classList.contains('nf-checked')) {
              jQuery(checkbox).trigger('click');
            }
          }

          // Nood medical section extra option
          if (medicalActive) {
            let checkbox = document.querySelector('.extra-option-medical-section-activate input[type="checkbox"]');

            if (checkbox && !checkbox.classList.contains('nf-checked')) {
              jQuery(checkbox).trigger('click');
            }
          } else {
            let checkbox = document.querySelector('.extra-option-medical-section-activate input[type="checkbox"]');

            if (checkbox && checkbox.classList.contains('nf-checked')) {
              jQuery(checkbox).trigger('click');
            }
          }

          // Nood access section extra option
          if (accessActive) {
            let checkbox = document.querySelector('.extra-option-access-section-activate input[type="checkbox"]');

            if (checkbox && !checkbox.classList.contains('nf-checked')) {
              jQuery(checkbox).trigger('click');
            }
          } else {
            let checkbox = document.querySelector('.extra-option-access-section-activate input[type="checkbox"]');

            if (checkbox && checkbox.classList.contains('nf-checked')) {
              jQuery(checkbox).trigger('click');
            }
          }

          if (activeBreadcrumb) {
            // Increase index by 1 due to first step
            let index = activeBreadcrumb.querySelector('a').dataset.index;

            if (index) {
              index++;

              // Remove "done" class and icon-ok from all steps
              progressBarSteps.forEach((step, index) => {
                step.classList.remove('done');
                step.classList.remove('active');
                step.innerHTML = index + 1;
              });

              // Add "done" class to all previous steps
              for (let i = 0; i < index; i++) {
                progressBarSteps[i].classList.add('done');
                progressBarSteps[i].innerHTML = '<i class="icon-ok">&#10004;</i>';
              }

              // Add "active" class to current step
              progressBarSteps[index].classList.add('active');
            }
          }

          const submitWrap = $('.submit-wrap');
          const nextNfFields = submitWrap.closest('nf-field').nextAll('nf-field');

          let fixedAmount = document.querySelector('.fixed-amount');
          let fixedAmountField = nextNfFields.eq(0).find('input');
          let orderDetails = nextNfFields.eq(1).find('input');
          let orderDetailsServiceOffers = nextNfFields.eq(2).find('input');
          let spoedtoeslagSelected = nextNfFields.eq(3).find('input');

          if (fixedAmount) {
            fixedAmount = fixedAmount.dataset.fixedAmount;
            if (fixedAmountField) {
              fixedAmountField.val(fixedAmount).trigger('change');
              if (localStorage.getItem('summaryHtml')) {
                let orderItemDetails = localStorage.getItem('summaryHtml');
                if (orderDetails) {
                  orderDetails.val(orderItemDetails).trigger('change');
                }
              }
            }
          }

          if (localStorage.getItem('serviceOffers')) {
            let serviceOffers = localStorage.getItem('serviceOffers');
            if (orderDetailsServiceOffers) {
              orderDetailsServiceOffers.val(serviceOffers).trigger('change');
            }
          }

          if (localStorage.getItem('spoedtoeslag')) {
            let spoedtoeslag = localStorage.getItem('spoedtoeslag');
            if (spoedtoeslagSelected) {
              spoedtoeslagSelected.val(spoedtoeslag).trigger('change');
            }
          }

          // Check form breadcrumbs to update progress bar
          breadcrumbsContainer = document.querySelector('.nf-mp-header');
          if (breadcrumbsContainer) {
            const observer = new MutationObserver(() => {
              console.log("initial observer run")
              updateProgressBarFromBreadcrumbs();
            });

            observer.observe(breadcrumbsContainer, {
              childList: true,
              subtree: true,
              attributes: true,
              attributeFilter: ['class', 'style']
            });
          }

          // Check bank number
          const ibanField = document.querySelector('input[placeholder="NL99 BANK 0123 4567 89"]');
          const errorContainer = document.createElement('div');
          errorContainer.classList.add('iban-error', 'nf-error-msg');
          errorContainer.textContent = 'Bankrekeningnummer is incorrect';

          if (ibanField) {
            const afterFieldContainer = ibanField.closest('.nf-field-container').querySelector('.nf-after-field');

            if(afterFieldContainer) {
              // Add error
              if (!afterFieldContainer.querySelector('.iban-error')) {
                afterFieldContainer.appendChild(errorContainer);
              }
            }

            ibanField.addEventListener('input', () => {
              const ibanValue = ibanField.value;
              const validIBAN = isValid(ibanValue);

              if (validIBAN) {
                document.body.classList.remove('iban-invalid');
              } else {
                document.body.classList.add('iban-invalid');
              }
            });
          }

          // Coupon validation
          const couponsRaw = Array.isArray(NodiCoupons) ? NodiCoupons : Object.values(NodiCoupons);
          const coupons = Array.isArray(couponsRaw[0]) ? couponsRaw[0] : couponsRaw;
          const submitBtn = document.querySelector('.submit-wrap input[type="submit"]');
          const errorEl = document.createElement('div');
          let couponField = document.querySelector('.nf-field-container.coupon-code input');

          errorEl.classList.add('coupon-error', 'nf-error-msg');
          errorEl.style.color = 'red';

          if (couponField) {
            couponField.addEventListener('input', () => {
                const enteredCode  = couponField.value.trim();
                const fixedAmountEl = document.querySelector('.fixed-amount');

                if (!enteredCode) {
                    errorEl.textContent = '';
                    submitBtn.disabled = false;
                }

                const matchedCoupon = coupons.find(
                    coupon => coupon.coupon_name.toLowerCase() === enteredCode.toLowerCase()
                );

                if (!matchedCoupon) {
                    errorEl.textContent = 'Kortingscode is ongeldig.';
                    submitBtn.disabled = true;
                    return;
                }

                if (!fixedAmountEl) {
                    errorEl.textContent = '';
                    submitBtn.disabled = false;
                    return;
                }

                const fixedAmount = parseFloat(fixedAmountEl.dataset.fixedAmount);
                const couponAmount = parseFloat(matchedCoupon.coupon_amount);

                if (couponAmount !== fixedAmount) {
                    errorEl.textContent = 'Kortingscode is ongeldig.';
                    submitBtn.disabled = true;
                    return;
                }

                // valid coupon + valid amount
                errorEl.textContent = '';
                submitBtn.disabled = false;
            });

            if(!document.querySelector('.coupon-error')) {
              couponField.parentNode.appendChild(errorEl);
            }
          }

          // Custom phone validation, exactly 10 digits, must start with zero and second char can't be zero
          let phoneFields = document.querySelectorAll('input[type="tel"]');
          if (phoneFields.length) {
            phoneFields.forEach(field => {

              const phoneContainer = field.closest('.phone-container');
              const nfContainer = field.closest('.nf-field-container');
              const afterFieldContainer = nfContainer.querySelector('.nf-after-field');

              // Add error once
              if (afterFieldContainer && !afterFieldContainer.querySelector('.phone-error')) {
                const phoneErrorContainer = document.createElement('div');
                phoneErrorContainer.classList.add('phone-error', 'nf-error-msg');
                phoneErrorContainer.textContent = 'Telefoonnummer is incorrect';
                phoneErrorContainer.style.display = 'none';
                afterFieldContainer.appendChild(phoneErrorContainer);
              }

              const validatePhone = value => {
                // must start with 0
                // second digit cannot be 0
                // total length exactly 10
                return /^0[1-9][0-9]{8}$/.test(value);
              };

                const getFieldLabel = (input) => {
                    const container = input.closest('.nf-field-container');
                    const label = container?.querySelector('label');

                    return Array.from(label.childNodes)
                                .filter(node => node.nodeType === Node.TEXT_NODE)
                                .map(node => node.textContent.trim())
                                .join(' ')
                                .replace(/\s+/g, ' ')
                                .trim();
                };

              const runValidation = () => {
                const cleanValue = field.value.replace(/\D/g, '');
                field.value = cleanValue;

                const isRequired = field.hasAttribute('required');
                const phoneError = nfContainer.querySelector('.phone-error');

                if (!isRequired && cleanValue === '') {
                  field.dataset.phoneValid = 'true';
                  phoneContainer.classList.remove('nf-error');
                  field.setAttribute('aria-invalid', 'false');
                  phoneError.style.display = 'none';
                  phoneError.textContent = '';
                  updateNextButtonState();
                  return;
                }

                const isValid = validatePhone(cleanValue);
                field.dataset.phoneValid = isValid ? 'true' : 'false';

                if (isValid) {
                  phoneContainer.classList.remove('nf-error');
                  field.setAttribute('aria-invalid', 'false');
                  phoneError.style.display = 'none';
                } else {
                  phoneContainer.classList.add('nf-error');
                  field.setAttribute('aria-invalid', 'true');
                  phoneError.style.display = 'block';

                  updateNextButtonState();
                  return;
                }

                for (const otherField of phoneFields) {
                    if (otherField === field) continue;

                    const otherValue = otherField.value.replace(/\D/g, '');
                    if (!otherValue) continue;

                    if (otherValue === cleanValue) {
                    const currentLabel = getFieldLabel(field);
                    const otherLabel = getFieldLabel(otherField);

                    if((currentLabel === 'Contactpersoon Telefoonnummer 1' || currentLabel === 'Contactpersoon Telefoonnummer 2') && (otherLabel.includes('1e') || otherLabel.includes('2e') || otherLabel.includes('3e')) ||
                       (otherLabel === 'Contactpersoon Telefoonnummer 1' || otherLabel === 'Contactpersoon Telefoonnummer 2') && (currentLabel.includes('1e') || currentLabel.includes('2e') || currentLabel.includes('3e'))
                    ) continue;

                    phoneError.textContent =
                        `${currentLabel} mag niet hetzelfde zijn als ${otherLabel}.`;

                    phoneError.style.display = 'block';
                    phoneContainer.classList.add('nf-error');
                    field.setAttribute('aria-invalid', 'true');
                    field.dataset.phoneValid = 'false';

                    updateNextButtonState();
                    return;
                    }
                }

                updateNextButtonState();
              };

              field.addEventListener('input', runValidation);
              field.addEventListener('blur', runValidation);
            });
          }

            // Huisnummer validation: only numeric [0-9], show error if invalid
            const huisnummerField = document.querySelector('.huisnummer-field input');

            if (huisnummerField) {
            const nfContainer = huisnummerField.closest('.nf-field-container');
            const afterFieldContainer = nfContainer.querySelector('.nf-after-field');

            // Add error once
            let huisnummerError;
            if (afterFieldContainer && !afterFieldContainer.querySelector('.huisnummer-error')) {
                huisnummerError = document.createElement('div');
                huisnummerError.classList.add('huisnummer-error', 'nf-error-msg');
                huisnummerError.textContent = 'Huisnummer is ongeldig';
                huisnummerError.style.display = 'none';
                afterFieldContainer.appendChild(huisnummerError);
            } else {
                huisnummerError = afterFieldContainer.querySelector('.huisnummer-error');
            }

            const validateHuisnummer = () => {
                const value = huisnummerField.value;

                // Invalid if contains anything other than digits
                const isValid = /^[0-9]*$/.test(value);

                if (!isValid) {
                nfContainer.classList.add('nf-error');
                huisnummerField.setAttribute('aria-invalid', 'true');
                huisnummerError.style.display = 'block';
                return;
                }

                // Empty → let Ninja Forms handle required error
                if (value === '') {
                huisnummerError.style.display = 'none';
                return;
                }

                // Valid
                nfContainer.classList.remove('nf-error');
                huisnummerField.setAttribute('aria-invalid', 'false');
                huisnummerError.style.display = 'none';
            };

            huisnummerField.addEventListener('input', validateHuisnummer);
            huisnummerField.addEventListener('blur', validateHuisnummer);
            }


          // Populate address via postcode API
          const postcodeField = document.querySelector('.postcode-field input');
          const houseNumberField = document.querySelector('.huisnummer-field input');

          if (postcodeField && houseNumberField) {
            postcodeField.addEventListener('blur', autofillAddress);
            houseNumberField.addEventListener('blur', autofillAddress);
          }
        });
      });

      jQuery(document).on('nfFormReady nfFormReadyResponse', function () {
        updateNextButtonState();
      });
    });
  }

  // Write down the summaryHtml to the order woocommerce template
  if (localStorage.getItem('summaryHtml') && localStorage.getItem('summaryHtml').length > 0) {
    // retrieve the saved summaryHtml
    let summaryHTML = localStorage.getItem('summaryHtml');

    // Get order review
    let orderReview = document.querySelector('#order_review');

    if(orderReview) {
      let summaryItem = document.createElement('tr');
      summaryItem.innerHTML = `
        <tr>
          <th scope="row" colspan="2">Samenvatting van uw bestelling</th>
          <td class="text-right">${summaryHTML}</td>
        </tr>`;

      orderReview.querySelector('tfoot').insertAdjacentElement('afterBegin', summaryItem);
    }
  }

  function toggleFormVisibility(forceShow = false) {
    const formSection = document.querySelector('.nodi-wizard-options__form');
    const mainItems = document.querySelectorAll('.cards__group');
    let hasActiveItem = false;

    if (mainItems.length > 0) {
      const lastMainItem = mainItems[mainItems.length - 1];
      const cardsInLastMainItem = lastMainItem.querySelectorAll('.card--wizard');

      cardsInLastMainItem.forEach((card) => {
        if (card.classList.contains('active')) {
          hasActiveItem = true;

          const footerCardSummary = document.querySelector('.nodi-wizard-options__footer .card--summary');
          if (footerCardSummary) {
            footerCardSummary.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      });
    }

    if (!formSection) return;

    if (forceShow && hasActiveItem) {
      formSection.classList.add('active');
      initialClickToShowForm = true;
      formLocked = true;

      setTimeout(() => {
        formSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 30)

    } else if (formLocked && !hasActiveItem) {
      formSection.classList.remove('active');
      formLocked = false;
      resetProgressBar();
    }
  }

  function updateProgressBarFromBreadcrumbs() {
    const breadcrumbs = document.querySelectorAll('.nf-breadcrumbs li:not(.hidden)');
    const progressBar = document.querySelector('.progress-bar');
    let formSection = document.querySelector('.nodi-wizard-options__form');

    if (!breadcrumbs.length || !progressBar) return;

    // Clear existing steps
    progressBar.innerHTML = '';

    const initialStep = document.createElement('div');
    initialStep.classList.add('progress-bar__step');
    initialStep.textContent = '1';
    initialStep.classList.add('active');
    initialStep.dataset.desc = 'Productselectie';

    // If the form is visible, user already passed this step → mark done
    if (formSection && formSection.classList.contains('active')) {
      initialStep.classList.add('done');
      initialStep.innerHTML = '<i class="icon-ok">&#10004;</i>';
    } else {
      initialStep.classList.add('active');
    }

    progressBar.appendChild(initialStep);

    breadcrumbs.forEach((crumb, index) => {
      const step = document.createElement('div');
      step.classList.add('progress-bar__step');
      step.textContent = index + 2;
      step.dataset.desc = crumb.textContent;

      // Copy active state
      if (crumb.classList.contains('active')) {
        if (formSection.classList.contains('active')) {
          step.classList.add('active');
        } else {
          step.classList.remove('active');
        }
      } else if (Array.prototype.indexOf.call(breadcrumbs, document.querySelector('.nf-breadcrumbs .active')) > index) {
        step.classList.add('done');
        step.innerHTML = '<i class="icon-ok">&#10004;</i>';
      }

      progressBar.appendChild(step);
    });
  }

  function resetProgressBar() {
    const progressBarSteps = document.querySelectorAll('.progress-bar__step');
    if (!progressBarSteps.length) return;

    progressBarSteps.forEach((step, i) => {
      step.classList.remove('done', 'active');
      step.innerHTML = i + 1;
    });

    // Only first step active
    progressBarSteps[0].classList.add('active');
  }

  // Getting address from postcode API call
  async function autofillAddress() {
    const postcodeField = document.querySelector('.postcode-field input');
    const houseNumberField = document.querySelector('.huisnummer-field input');
    const streetField = document.querySelector('.straatnaam-field input');
    const cityField = document.querySelector('.woonplaats-field input');

    if (!postcodeField || !houseNumberField || !streetField || !cityField) return;

    const postcode = postcodeField.value.trim().replace(/\s+/g, '');
    const number = houseNumberField.value.trim();

    if (!postcode || !number) return;

    const formData = new FormData();
    formData.append('action', 'nodi_postcode_lookup');
    formData.append('postcode', postcode);
    formData.append('number', number);

    try {
      const response = await fetch('/wp-admin/admin-ajax.php', {
        method: 'POST',
        body: formData
      });

      const result = await response.json();

      if (!result.success) return;

      streetField.value = result.data.street;
      cityField.value = result.data.city;

      streetField.dispatchEvent(new Event('input', { bubbles: true }));
      streetField.dispatchEvent(new Event('change', { bubbles: true }));
      streetField.dispatchEvent(new Event('blur', { bubbles: true }));

      cityField.dispatchEvent(new Event('input', { bubbles: true }));
      cityField.dispatchEvent(new Event('change', { bubbles: true }));
      cityField.dispatchEvent(new Event('blur', { bubbles: true }));

    } catch (err) {
      console.error('Postcode lookup failed', err);
    }
  }
});
